import React from 'react'
import FormROValue from '../../../../../library/form/components/FormROValue1';
import FormLink from '../../../../../library/form/components/FormLink';
import FormInput from '../../../../../library/form/components/FormInput';
import FormButton from '../../../../../library/form/components/FormActionButton2';

const ProdIOOExiBomRow = (props) => {
    const { formObject, index, rowKey } = props;

        return (
            <ul className="uiDPEditLine">
                <li className="uiColumnCenter uiColumn50">
                    <span>{index}</span>
                </li>
                <li className="uiColumnCenter uiColumn70">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "id" }} />
                </li>
                <li className="uiColumnCenter uiColumn200">
                    <FormLink formObject={formObject} rowKey={rowKey} kscFormula=""
                        action={{ paramName: "actualItem", actionId: "show" }}
                        linkProp={{ target: "_blank" }}
                    ></FormLink>
                </li>
                <li className="uiColumnCenter uiColumn50">
                    <FormROValue format="" formObject={formObject} rowKey={rowKey} action={{ paramName: "units" }} />
                </li>
                <li className="uiColumnCenter uiColumn70">
                    <FormInput formObject={formObject} rowKey={rowKey} className="uiInput widthInherit"
                            action={{ InputType: "input", actionId: "refresh", paramName: "qtyRequired1", actionParam:{"formulaSource":"req", "updateQty":1} }} />
                </li>
                <li className="uiColumnCenter uiColumn70">
                    <FormInput formObject={formObject} rowKey={rowKey} className="uiInput widthInherit" 
                            action={{ InputType: "input", actionId: "refresh", paramName: "qtyRequired2", actionParam:{"formulaSource":"req", "updateQty":1} }} />
                </li>
                <li className="uiColumnCenter uiColumn70">
                    <FormInput formObject={formObject} rowKey={rowKey} className="uiInput widthInherit"
                            action={{ InputType: "input", actionId: "refresh", paramName: "qtyAllocated1", actionParam:{"updateQty":1} }} />
                </li>
                <li className="uiColumnCenter uiColumn70">
                    <FormInput formObject={formObject} rowKey={rowKey} className="uiInput widthInherit" 
                            action={{ InputType: "input", actionId: "refresh", paramName: "qtyAllocated2", actionParam:{"updateQty":1} }} />
                </li>
                <li className="uiColumnCenter uiColumn60 uiActionBlock">
                    <FormButton formObject={formObject} rowKey={rowKey}
                        starIcon="clear"
                        onlyIcon={true}
                        tooltip="Delete"
                        starIconClassName="uiColorNegativeAction"
                        action={{ actionId: "del",  actionParam: {}, containerKey: "row" }}
                        className="" ></FormButton>
                </li>
            </ul>
        )
}

export default ProdIOOExiBomRow